export enum BespokeType {
  Single = 'ai_solitaire',
  Pair = 'ai_pair'
}
